import React from "react";
import { useConsolidatedPaymentPrefContext } from "../../Context";
import { ExistingPaymentPrefDisplayCard } from "../ExistingPaymentPrefDisplayCard";
import { PreviewPaymentPrefDisplayCard } from "../PreviewPaymentPrefDisplayCard";

export const PaymentPrefConfirmationDisplayCard: React.FC = () => {
  const { paymentPrefDetail, selectedPaymentPref } = useConsolidatedPaymentPrefContext();

  let paymentPrefDisplay = null;
  if (paymentPrefDetail) {
    paymentPrefDisplay = <PreviewPaymentPrefDisplayCard paymentPref={paymentPrefDetail} />;
  } else if (selectedPaymentPref) {
    paymentPrefDisplay = (
      <ExistingPaymentPrefDisplayCard paymentPref={selectedPaymentPref} displayRevealDetails />
    );
  }

  return paymentPrefDisplay;
};
